import { OrganisationPermissionConstants } from "../../../constants";
import { AssetManagerSingleCardWithTabsTemplate } from "../../../templates";
import { useAuth } from "../../../useAuth";
import {
  getSettingsAuditHistoryRoute,
  getSettingsProjectAccessRoute,
  getUserSettingsOrganisationRoute,
  getUserSettingsRoute,
} from "../../../utils/routes";

const Settings = (): JSX.Element => {
  const { hasPermission, currentUserType } = useAuth();

  return (
    <div>
      <AssetManagerSingleCardWithTabsTemplate
        activeElement="Settings"
        pageTitle="Settings"
        tabsList={
          hasPermission(OrganisationPermissionConstants.READ_ORGANISATION_USERS)
            ? [
                { route: getUserSettingsRoute(currentUserType), label: "Users" },
                { route: getUserSettingsOrganisationRoute(currentUserType), label: "Organisation" },
                { route: getSettingsProjectAccessRoute(currentUserType), label: "Project access" },
                { route: getSettingsAuditHistoryRoute(currentUserType), label: "Audit history" },
              ]
            : [
                { route: getUserSettingsOrganisationRoute(currentUserType), label: "Organisation" },
                { route: getSettingsProjectAccessRoute(currentUserType), label: "Project access" },
                { route: getSettingsAuditHistoryRoute(currentUserType), label: "Audit history" },
              ]
        }
        hasBackground={false}
      />
    </div>
  );
};

export default Settings;
